import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import { AlertSearchPage } from './pages/AlertSearchPage';
import { AlertDetailPage } from './pages/AlertDetailPage';
import { LocationsOverviewPage } from './pages/LocationsOverviewPage';
import { LocationDetailPage } from './pages/LocationDetailPage';
import { HazardPage } from './pages/HazardPage';
import { SavedLocationsPage } from './pages/SavedLocationsPage';
import { EmbedWidgetPage } from './pages/EmbedWidgetPage';
import { HistoryPage } from './pages/HistoryPage';
import { AboutPage } from './pages/AboutPage';
import { DataSourcesPage } from './pages/DataSourcesPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ContactPage } from './pages/ContactPage';
import { NotFoundPage } from './pages/NotFoundPage';

// Helper component to scroll to top whenever the route changes
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-slate-50 text-navy-900">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/alerts" element={<AlertSearchPage />} />
            <Route path="/alert/:id" element={<AlertDetailPage />} />
            <Route path="/hazards/:type" element={<HazardPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/saved" element={<SavedLocationsPage />} />
            <Route path="/embed" element={<EmbedWidgetPage />} />
            <Route path="/locations" element={<LocationsOverviewPage />} />
            <Route path="/location/:code" element={<LocationDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/sources" element={<DataSourcesPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
